import React from "react";

export const WAHeader: React.FC<{}> = ({ children }) => {
  return (
    <header className="wa-header">
      <div className="wa-header-container">{children}</div>
    </header>
  );
};
